module.exports = __webpack_public_path__ + "static/media/admission_process.f9a02cb5.JPG";